if( document.querySelector( '#interim-billing' ) !== null && location.search !== '' ) {
    // get form
    var form = document.querySelector( '#interim-billing form' );
    // create input
    var el = document.createElement( 'input' );
    // get token
    var token = location.search;
    // get submit button
    var submitButton = document.querySelector( '#interim-billing input[type="submit"]' );
    // define target URL
    var targetURL = 'https://privatkundenportal.net/wolfhagen/zaehlerstandserfassung/auth/';
    // replace URL parameter
    token = token.replace( '?token=', '' );
    // build input an append
    el.type = 'hidden';
    el.name = 'token';
    el.value = token;
    form.append( el );
    // redirect after click
    submitButton.addEventListener( 'click', function( event ) {
        window.open( targetURL+token, '_blank' ).focus();
        return false;
    } );
}